<template>
  <div>
    <Card shadow>
      <Form :label-width="80">
        <Row :gutter="24">
          <Col span="6">
            <FormItem label="玩家ID">
              <Input
                v-model="formData.user_id"
                placeholder="请输入玩家ID"
                clearable
              ></Input>
            </FormItem>
          </Col>

          <Col span="6">
            <FormItem label="三方账号">
              <Input
                v-model="formData.external_account"
                placeholder="请输入三方账号"
                clearable
              ></Input>
            </FormItem>
          </Col>

          <Col span="6">
            <FormItem label="所属代理">
              <Select
                v-model="formData.app_id"
                filterable
                placeholder="选择所属代理"
                clearable
                @on-change="agentChange"
              >
                <Option
                  v-for="item in app_list"
                  :value="item.appid"
                  :label="item.appName"
                  :key="item.appid"
                >
                  {{ item.appName }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col span="6">
            <FormItem label="所属商户">
              <Select
                v-model="formData.general"
                filterable
                placeholder="选择所属商户"
                clearable
              >
                <Option
                  v-for="item in select.generalList"
                  :value="item.general"
                  :label="item.general_name"
                  :key="item.general"
                >
                  {{ item.general_name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>

        <Row :gutter="24">
          <Col span="6">
            <FormItem label="所属子商户">
              <Select
                v-model="formData.pack_no"
                filterable
                placeholder="选择所属子商户"
                clearable
              >
                <Option
                  v-for="item in packList"
                  :value="item.pack_no"
                  :label="item.pack_name"
                  :key="item.pack_no"
                >
                  {{ item.pack_name }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col span="6">
            <FormItem label="账号状态">
              <Select
                v-model="formData.user_status"
                filterable
                placeholder="选择账号状态"
                clearable
              >
                <Option
                  v-for="item in select.user_status"
                  :value="item.value"
                  :label="item.name"
                  :key="item.value"
                >
                  {{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col span="6">
            <Button
              type="primary"
              style="margin-right:10px"
              @click="getListData"
              >搜索</Button
            >
            <Button style="margin-right:10px" @click="resetData">重置</Button>
            <Button @click="exportData">导出</Button>
          </Col>
        </Row>
      </Form>
    </Card>

    <Table
      border
      style="margin-top:12px;"
      :columns="table.colums"
      :data="table.data"
      ref="tableRef"
      :max-height="tableMaxHeight"
    >
      <template #statusAction="{ row }">
        <i-switch
          :value="row.isActive"
          v-model="row.isActive"
          @on-change="val => onChangeStatus(val, row)"
          size="large"
        >
          <span slot="open">启用</span>
          <span slot="close">禁用</span>
        </i-switch>
      </template>
    </Table>

    <Page
      style="margin-top:10px;"
      :total="page.total"
      show-total
      :current="page.currentPage"
      :page-size-opts="page.pageSizes"
      :page-size="page.pagesize"
      show-sizer
      @on-page-size-change="pageSizeChange"
      @on-change="pageChange"
    ></Page>

    <LoginLogModal
      :visible="showLogModal"
      :currentData="checkedItemData"
      @close="showLogModal = false"
    ></LoginLogModal>
  </div>
</template>

<script>
import transToReq from '@/api/trans'
import LoginLogModal from './loginLogModal.vue'

export default {
  name: 'playerManager',
  components: {
    LoginLogModal
  },
  data() {
    return {
      tableMaxHeight: 0,
      select: {
        packList: [],
        user_status: [
          { value: 0, name: '全部' },
          { value: 1, name: '封号' },
          { value: 2, name: '正常' }
        ],
        generalList: []
      },
      formData: {
        app_id: -1,
        pack_no: -1,
        external_account: '',
        user_id: '',
        general: -1,
        user_status: 0
      },
      table: {
        data: [],
        colums: [
          { key: 'user_id', title: '玩家ID', align: 'center', resizable: true },
          { key: 'name', title: '玩家昵称', align: 'center', resizable: true },
          {
            key: 'external_account',
            title: '三方账号',
            align: 'center',
            resizable: true
          },
          {
            key: 'app_id',
            title: '所属代理',
            align: 'center',
            resizable: true,
            render: (h, params) => {
              const { row } = params

              const item = this.app_list.find(i => i.appid === row.app_id)

              return h('span', `${item && item.appName}(${row.app_id})`)
            }
          },
          {
            key: 'pack_name',
            title: '所属子商户',
            align: 'center',
            resizable: true
          },
          {
            key: 'register_time',
            title: '注册时间',
            align: 'center',
            resizable: true
          },
          {
            key: 'regster_ip',
            title: '注册IP',
            align: 'center',
            resizable: true
          },
          {
            key: 'is_online',
            title: '在线状态',
            align: 'center',
            resizable: true,
            render: (h, params) => {
              const { row } = params
              const val = row['is_online']
              const colorMap = {
                '0': '#999',
                '1': 'green'
              }
              const txtMap = {
                '0': '离线',
                '1': '在线'
              }

              return h('span', { style: { color: colorMap[val] } }, txtMap[val])
            }
          },
          {
            slot: 'statusAction',
            title: '账号状态',
            align: 'center',
            resizable: true
          },
          {
            key: 'options',
            title: '操作',
            width: 300,
            align: 'center',
            resizable: true,
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.$router.push(
                          '/Report/APIReport2?user_id=' + params.row.user_id
                        )
                      }
                    }
                  },
                  '查看用户'
                ),
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.showLogModal = true
                        this.checkedItemData = params.row
                      }
                    }
                  },
                  '登录日志'
                )
              ])
            }
          }
        ]
      },
      page: {
        total: 0,
        totalSum: 0,
        pagesize: 15,
        pageSizes: [15, 30, 45, 60],
        currentPage: 1
      },
      // 登录日志相关
      showLogModal: false,
      checkedItemData: {}
    }
  },
  computed: {
    packList() {
      const filtPack = this.select.packList.filter(
        item => item.general === this.formData.general
      )

      return filtPack
    }
  },
  methods: {
    // 获取数据
    async getData() {
      const params = {
        page: this.page.currentPage,
        limit: this.page.pagesize,
        app_id: this.formData.app_id ? this.formData.app_id : -1,
        general: this.formData.general ? this.formData.general : -1,
        pack_no: this.formData.pack_no ? this.formData.pack_no : -1,
        user_id: this.formData.user_id ? Number(this.formData.user_id) : 0,
        external_account: this.formData.external_account,
        user_status: this.formData.user_status
      }
      try {
        const res = await transToReq('GetUserList', params)
        const rp = res._param
        const res2 = await transToReq('GetUserList2', {
          page: this.page.currentPage,
          limit: this.page.pagesize,
          total: rp.total,
          app_id: rp.app_id,
          list: rp.list
        })
        return res2
      } catch (err) {
        return err
      }
    },
    // 获取列表数据
    async getListData() {
      try {
        const res = await this.getData()
        const data = res._param

        this.page.total = data.total
        if (data.list) {
          const list = []
          data.list.map(item => {
            if (item.status == 0) {
              item.isActive = true
            } else {
              item.isActive = false
            }
            list.push(item)
          })
          this.table.data = list
        }
      } catch (error) {
        console.log(error)
      }
    },
    pageChange(page) {
      this.page.currentPage = page
      this.getListData()
    },
    pageSizeChange(size) {
      this.page.pagesize = size
      this.getListData()
    },
    // 重置数据
    resetData() {
      this.formData = {
        app_id: -1,
        pack_no: -1,
        external_account: '',
        user_id: '',
        general: -1,
        user_status: 0
      }
    },
    // 数据导出
    async exportData() {
      try {
        const res = await this.getData()
        const data = res._param
        const txtMap = {
          '0': '离线',
          '1': '在线'
        }
        data.list.forEach(item => {
          item.is_online = txtMap[item.is_online]
        })

        if (data.list) {
          this.$refs.tableRef.exportCsv({
            filename: '玩家管理',
            original: false,
            data: data.list,
            columns: this.table.colums
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    agentChange() {
      this.getGeneralList()
    },
    // 当前代理商户数据
    getGeneralList() {
      transToReq('GetAppGeneralList', {
        app_id: this.formData.app_id
      }).then(res => {
        this.select.generalList = res._param.general_list
      })
    },
    // 获取子商户数据
    getPackList() {
      transToReq('GetPackList', {
        app_id: this.formData.app_id
      }).then(res => {
        this.select.packList = res._param.pack_list
      })
    },
    onChangeStatus(val, row) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认启用/禁用</p>',
        onOk: () => {
          const params = {
            app_id: this.formData.app_id,
            user_id: row.user_id
          }
          if (val) {
            params.type = 9
            params.un_bind_back = 1
          } else {
            params.type = 4
          }
          transToReq('UpdateUserInfo', params).then(res => {
            this.$Message.success('操作成功')
            const t = setTimeout(() => {
              this.getListData()
              clearTimeout(t)
            }, 1000)
          })
        },
        onCancel: () => {
          if (val) {
            row.isActive = false
          } else {
            row.isActive = true
          }
        }
      })
    }
  },
  activated() {
    // 设置代理
    this.formData.app_id = this.app_list[0].appid
    // 初始化列表数据
    this.getListData()
    this.getGeneralList()
    this.getPackList()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 320
  }
}
</script>
